import { Input, InputGroup } from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { CSSProperties, useEffect } from 'react';

interface IProps {
  setValue: React.Dispatch<React.SetStateAction<string>>;
  value?: string;
  placeholder?: string;
  styles?: CSSProperties;
  inputGroupProps?: Record<string, any>;
}

export const SearchInput = ({
  placeholder,
  setValue,
  value,
  styles,
  inputGroupProps
}: IProps) => {
  useEffect(() => {
    if (value === undefined) {
      setValue('');
    }
  }, [value]);
  return (
    <InputGroup {...inputGroupProps} inside style={styles}>
      <InputGroup.Addon>
        <SearchIcon />
      </InputGroup.Addon>
      <Input
        placeholder={placeholder}
        onChange={(value, e) => {
          setValue(e.target.value);
        }}
        onClick={(e) => e.stopPropagation()}
        autoFocus
      />
    </InputGroup>
  );
};
